import { AbstractMesh, StandardMaterial, Color3 } from '@babylonjs/core';
import { IItemSection, ItemSection } from './itemSection';
import { ItemParams } from './itemParams';
import { IEvent, Event } from './event';
import { ElementType } from './element';

export interface ISectionCreator {
    onSectionsChanged: IEvent<IItemSection[]>;
    create(meshes: AbstractMesh[]): void;
    initialize(scenePreview: any): void;
}

export class SectionCreator implements ISectionCreator {
    get onSectionsChanged() { return this._onSectionChanged.expose(); }

    private _onSectionChanged = new Event<IItemSection[]>();
    private sections = new Map<AbstractMesh, IItemSection>();
    private scenePreview: any = null;

    private constSections: IItemSection[] = [
        new ItemSection("Kolor korpusu", [
            new ItemParams("#937952", "", "H3395", (x) => {
                this.scenePreview.changeColors(ElementType.BODY, x.text)
            }, true),
            new ItemParams("#192e24", "", "U606", (x) => {
                this.scenePreview.changeColors(ElementType.BODY, x.text)
            }),
            new ItemParams("#908b85", "", "U8101", (x) => {
                this.scenePreview.changeColors(ElementType.BODY, x.text)
            }),
            new ItemParams("#c79832", "", "U163", (x) => {
                this.scenePreview.changeColors(ElementType.BODY, x.text)
            })
        ]),
        new ItemSection("Kolor frontów", [
            new ItemParams("#937952", "", "H3395", (x) => {
                this.scenePreview.changeColors(ElementType.FRONT, x.text)
            }, true),
            new ItemParams("#192e24", "", "U606", (x) => {
                this.scenePreview.changeColors(ElementType.FRONT, x.text)
            }),
            new ItemParams("#908b85", "", "U8101", (x) => {
                this.scenePreview.changeColors(ElementType.FRONT, x.text)
            }),
            new ItemParams("#c79832", "", "U163", (x) => {
                this.scenePreview.changeColors(ElementType.FRONT, x.text)
            })
        ]),
        new ItemSection("Klamki", [
            new ItemParams("#ffffff", "", "brak", (x) => {
                console.log(x.text)
            }, true),
        ]),
    ]

    public initialize(scenePreview: any): void {
        this.scenePreview = scenePreview;
        this._onSectionChanged.trigger(this.constSections);
    }

    public create(meshes: AbstractMesh[]) {
        const keys = Array.from(this.sections.keys());
        keys.forEach((x) => this.sections.delete(x));
        meshes
            .forEach((x: AbstractMesh) => {
                const m = (x.material as StandardMaterial);
                const params = [
                    new ItemParams("#ffffff", "", "clear", () => {
                        m!.emissiveColor = new Color3(0, 0, 0);
                    }, true),
                    new ItemParams("#ff0000", "", "red", () => {
                        m!.emissiveColor = new Color3(1, 0, 0);
                    }),
                    new ItemParams("#00ff00", "https://localhost:44332/api/download/1.jpg", "green", () => {
                        m!.emissiveColor = new Color3(0, 1, 0);
                    }),
                    new ItemParams("#0000ff", "https://localhost:44332/api/download/2.jpg", "blue", () => {
                        m!.emissiveColor = new Color3(0, 0, 1);
                    }),
                ];
                this.sections.set(x, new ItemSection("Wybierz kolor korpusu", params));
            })
        const result = this.createConstResult();
        result.push(...Array.from(this.sections.values()));
        this._onSectionChanged.trigger(result);
    }

    private createConstResult(): IItemSection[] {
        const result = [];
        result.push(...this.constSections);
        return result;
    }
}